import { ApiServiceBase } from '../../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProductTypeGroupService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/product"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getAll() {
    return this.httpGet<any>(this.REFERENCE_PATH + "/producttypegroup", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }

  public getByProductGroup(productGroupCode) {
    let params = new HttpParams()
      .set("productGroupCode", productGroupCode);
    return this.httpGet<any>(this.REFERENCE_PATH + "/producttypegroup", params)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }
}